import { NgModule } from '@angular/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignupSuccessComponent } from './signup-success/signup-success.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotPasswordService } from './forgot-password.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { LoginService } from './login.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthComponent } from './auth/auth.component';
import { LogoutComponent } from './logout/logout.component';
import { AlwaysAuthGuardService } from './always-auth-guard.service';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserProfileService } from './user-profile/user-profile.service';
import { AuthService } from './auth/auth.service';
import { PropertiesComponent } from './properties/properties.component';
import { PropertiesService } from './properties/properties.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { HomeComponent } from './home/home.component';
import { ArticleComponent } from './article/article.component';
import { TokenInterceptor } from './auth/token.interceptor';
import { HeaderInterceptor } from './auth/header.interceptor';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { TitleCasePipe } from '@angular/common';
import { DashboardService } from './dashboard/dashboard.service';
import { ContactUsService } from './contact-us/contact-us.service';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { FooterComponent } from './shared/footer/footer.component';
import { PdfServiceService } from './pdf-service.service';

@NgModule( {
    declarations: [
        AppComponent,
        SignupSuccessComponent,
        DashboardComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        LoginComponent,
        AuthComponent,
        LogoutComponent,
        UserProfileComponent,
        PropertiesComponent,
        HomeComponent,
        ArticleComponent,
        ContactUsComponent,
        FooterComponent
        // SpinnerComponent,
        // AssessmentComponent,
    ],
    imports: [
        NgxUsefulSwiperModule,
        AppRoutingModule,
        HttpClientModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPaginationModule,
        Ng2SearchPipeModule,
        Ng2OrderModule,
        AngularMultiSelectModule
    ],
    providers: [
        TitleCasePipe,
        LoginService,
        ForgotPasswordService,
        CookieService,
        AlwaysAuthGuardService,
        UserProfileService,
        PropertiesService,
        DashboardService,
        PdfServiceService,
        ContactUsService, {
            provide: HTTP_INTERCEPTORS,
            useClass: HeaderInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        AuthService
    ],
    bootstrap: [ AppComponent ]
} )
export class AppModule {
}
